<ng-container *appI18nScopeReady>
  @if (this.dashboards.length === 0 && !loading()) {
    <app-empty-state-card
      [title]="'no_dashboards_title' | i18n"
      [hint]="canEdit() ? ('no_dashboards_hint' | i18n) : null"
    >
      @if (canEdit()) {
        <button mat-flat-button type="button" (click)="createDashboard()">
          <mat-icon>add</mat-icon>
          {{ 'create_dashboard_btn' | i18n }}
        </button>
      }
    </app-empty-state-card>
  }
</ng-container>
